module.exports = __webpack_public_path__ + "fdb15f43430277005f594e37f61af4e5.svg";